<script lang="ts">
  import { router } from '@inertiajs/svelte';

  type Member = {
    id: string; threads_username: string; display_name: string | null; email: string | null;
    tier: string; tier_label: string; tier_hex: string;
    interests: string[]; joined_at: string | null; active: boolean; admin_notes: string | null;
  };

  let { members, tier_counts, total, filter }: {
    members: Member[]; tier_counts: Record<string, number>; total: number;
    filter: { tier?: string };
  } = $props();

  const tiers = ['yellow', 'green', 'blue'];
  let activeFilter = $state(filter.tier ?? '');

  function setFilter(t: string) {
    activeFilter = t;
    router.get('/admin/community/members', { tier: t || undefined },
               { preserveState: true, replace: true });
  }

  function promote(id: string, tier: string) {
    router.post(`/admin/community/members/${id}/promote`, { tier });
  }

  function exportCsv() { window.location.href = '/admin/community/members/export_csv'; }
</script>

<div class="p-6 space-y-6">
    <header class="flex justify-between">
      <h1 class="text-2xl font-bold">스터디 멤버</h1>
      <button onclick={exportCsv} class="px-4 py-2 bg-gray-200 rounded">📥 CSV</button>
    </header>

    <div class="flex gap-2">
      <button onclick={() => setFilter('')}
              class="px-3 py-1 rounded border {activeFilter === '' ? 'bg-gray-900 text-white' : ''}">
        전체 ({total})
      </button>
      {#each tiers as t}
        <button onclick={() => setFilter(t)}
                class="px-3 py-1 rounded border {activeFilter === t ? 'bg-gray-900 text-white' : ''}">
          {t.toUpperCase()} ({tier_counts?.[t] ?? 0})
        </button>
      {/each}
    </div>

    <table class="w-full bg-white border">
      <thead class="bg-gray-50 text-left text-sm">
        <tr>
          <th class="p-3">Threads</th>
          <th class="p-3">이름</th>
          <th class="p-3">반</th>
          <th class="p-3">관심</th>
          <th class="p-3">가입</th>
          <th class="p-3">반 이동</th>
        </tr>
      </thead>
      <tbody>
        {#each members as m}
          <tr class="border-t">
            <td class="p-3">@{m.threads_username}</td>
            <td class="p-3">{m.display_name ?? '-'}</td>
            <td class="p-3"><span class="px-2 py-1 rounded text-white" style="background-color: {m.tier_hex}">{m.tier_label}</span></td>
            <td class="p-3 text-xs">{m.interests.join(', ')}</td>
            <td class="p-3 text-xs">{m.joined_at ? new Date(m.joined_at).toLocaleDateString('ko') : '-'}</td>
            <td class="p-3 space-x-1">
              {#each tiers.filter(t => t !== m.tier) as t}
                <button onclick={() => promote(m.id, t)}
                        class="px-2 py-0.5 text-xs border rounded">→ {t}</button>
              {/each}
            </td>
          </tr>
        {/each}
        {#if members.length === 0}
          <tr><td colspan="6" class="p-6 text-center text-gray-500">멤버 없음</td></tr>
        {/if}
      </tbody>
    </table>
  </div>
